import React, { memo } from "react";
import { useTable } from "../../Components/useTable";

const AllMoments = () => {
  const type = "All Moments";
  const limitPerpage = 100;
  const pageRowslinit = [20,50,100];
  const headCells = [
    { id: "username", numeric: false, label: "User Name" },
    { id: "picture", numeric: false, label: "Image" },
    { id: "country", numeric: false, label: "Country" },
    { id: "fileType", numeric: false, label: "File Type" },
    { id: "status", numeric: false, label: "Status" },
    { id: "dropdown", numeric: false, label: "Change Status" },
    { id: "description", numeric: false, label: "Description" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default AllMoments;
